{
  "name": "@accrupay/node",
  "private": false,
  "version": "0.15.1",
  "description": "SDK client for AccruPay Merchant API",
  "license": "MIT",
  "author": "Luiz Felipe Laviola <luiz@laviola.dev>",
  "homepage": "https://accru.co",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/accruteam/sdk-accrupay-node"
  },
  "bugs": {
    "url": "https://github.com/accruteam/sdk-accrupay-node/issues"
  },
  "keywords": [
    "accru",
    "accrupay",
    "payment",
    "node",
    "graphql",
    "nuvei"
  ],
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    "require": {
      "types": "./dist/index.d.cts",
      "require": "./dist/index.cjs"
    },
    "node": {
      "types": "./dist/index.d.cts",
      "require": "./dist/index.cjs",
      "import": "./dist/index.cjs"
    },
    "import": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js"
    }
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "build": "tsup",
    "watch": "tsup --watch",
    "start": "./scripts/run.sh",
    "test": "vitest -c ./test/vitest.config.ts run",
    "test:watch": "vitest -c ./test/vitest.config.ts",
    "lint": "run-p -c lint:*",
    "lint:eslint": "eslint 'src/**/*.{ts,tsx}' --fix",
    "lint:tsc": "tsc --noEmit",
    "codegen": "graphql-codegen",
    "codegen:update": "graphql-codegen && yalc publish",
    "codegen:watch": "graphql-codegen -w",
    "release": "npm run build && changeset publish",
    "prepare": "husky"
  },
  "dependencies": {
    "@apollo/client": "^3.13.9",
    "apollo-link-scalars": "^4.0.3",
    "graphql": "^16.12.0",
    "graphql-scalars": "^1.25.0"
  },
  "devDependencies": {
    "@changesets/cli": "^2.29.7",
    "@commitlint/cli": "^20.1.0",
    "@commitlint/config-conventional": "^20.0.0",
    "@eslint/compat": "^1.4.1",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.39.0",
    "@faker-js/faker": "^10.1.0",
    "@graphql-codegen/cli": "^6.0.1",
    "@graphql-codegen/client-preset": "^5.1.1",
    "@graphql-codegen/introspection": "^5.0.0",
    "@graphql-codegen/schema-ast": "^5.0.0",
    "@graphql-codegen/typescript": "^5.0.2",
    "@graphql-codegen/typescript-operations": "^5.0.2",
    "@graphql-typed-document-node/core": "^3.2.0",
    "@paralleldrive/cuid2": "^3.0.4",
    "@parcel/watcher": "^2.5.1",
    "@types/node": "^24.10.0",
    "@typescript-eslint/eslint-plugin": "^8.46.2",
    "@typescript-eslint/parser": "^8.46.2",
    "@vitest/coverage-v8": "^4.0.6",
    "commitizen": "^4.3.0",
    "cz-conventional-changelog": "^3.3.0",
    "dotenv": "^17.2.3",
    "eslint": "^9.39.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-prettier": "^5.5.4",
    "globals": "^16.5.0",
    "husky": "^9.1.6",
    "lint-staged": "^16.2.6",
    "npm-run-all": "^4.1.5",
    "prettier": "^3.6.2",
    "slackify-markdown": "^4.5.0",
    "tsup": "^8.5.0",
    "typescript": "5.9.3",
    "vite-tsconfig-paths": "^5.1.0",
    "vitest": "^4.0.6"
  },
  "lint-staged": {
    "**/*.{ts,tsx}": [
      "eslint 'src/**/*.{ts,tsx}' --fix"
    ]
  },
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-conventional-changelog"
    }
  },
  "commitlint": {
    "extends": [
      "@commitlint/config-conventional"
    ]
  }
}
